import PropTypes from "prop-types"
import { React, useState } from "react"
import { Col, Form, FormFeedback, Input, Label, Modal, Row } from "reactstrap"
//redux
import { useDispatch, useSelector } from "react-redux"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"

import * as CONSTANTS from "../../../common/utils/data_validations"
import Select from "react-select"
import { getPrimaryButtonClass } from "helpers/sf_utils"
import { customer_incident_status } from "helpers/sf_constants"
import { createCustomerIncidents } from "store/admin/status-monitor/actions"
import { format } from "date-fns"

const CustomerIncidentModal = ({ show, onSaveCustomerIncident, onCloseClick }) => {
  const dispatch = useDispatch()
  const [selectedStatus, setSelectedStatus] = useState(null)

  const { current_admin_user } = useSelector(state => ({
    current_admin_user: state.LoginAdminUser.current_user
}));


  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      description: "",
      status: {},
      reported_at: '',
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required(CONSTANTS.STR_REQUIRED_TITLE)
        .min(2),
      description: Yup.string()
        .required(CONSTANTS.STR_REQUIRED_FIELD)
        .min(2),
      status: Yup.object().shape({
       label: Yup.string().required(),
       value: Yup.string().required(),
      }),
      reported_at: Yup.string()
        .required(CONSTANTS.STR_REQUIRED_FIELD)
    }),
    onSubmit: values => {
      console.log('values', values)
      const submitValues = JSON.parse(JSON.stringify(values));
      submitValues.status = values.status.value; // For Select Fields
      let admin_user_id = current_admin_user?.admin_role?.id
      dispatch(createCustomerIncidents(
        {
          ...submitValues, 
          'admin_user_id': admin_user_id,
          'reported_at': format(new Date(values.reported_at), "yyyy-MM-dd HH:mm:ss 'UTC'"), 
        }))
      onSaveCustomerIncident()
      validation.handleReset()
    },
  })

  function handleSelectStatus(status) {
    setSelectedStatus(status)
  }

  const statusGroup = [];
  customer_incident_status.map((e) => {
    statusGroup.push({ label: e.value, value: e.name });
  });
  const optionGroupStatus = [
    {
      label: 'Select Status',
      options: statusGroup,
    },
  ];

  const onCloseClickModal = () => {
    onCloseClick()
    validation.handleReset()
  }

  return (
    <Modal isOpen={show} toggle={onCloseClickModal} centered={true}>
      <div className="modal-header">
        <h5 className="modal-title text-black mt-0" id="myModalLabel">
          Customer Incident
        </h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={onCloseClickModal}
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <Form
        onSubmit={e => {
          e.preventDefault()
          validation.handleSubmit()
          return false
        }}
      >
        <div className="modal-body noscrollbar">
          <Row>
            <Col xl={12}>
              <div className="mb-3">
                <Label className='form-label'>Title</Label>
                <Input
                  type="text"
                  name="title"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.title || ""}
                  invalid={
                    validation.touched.title &&
                    validation.errors.title
                      ? true
                      : false
                  }
                ></Input>
                {validation.touched.title &&
                  validation.errors.title ? (
                    <FormFeedback type="invalid">
                      {validation.errors.title}
                    </FormFeedback>
                  ) : null}
              </div>
            </Col>
            <Col xl={6}>
            <div className="mb-3">
                <Label className='form-label'>Select Severity</Label>
                <Select
                  options={optionGroupStatus}
                  classNamePrefix="select2-selection"
                  menuPortalTarget={document.body} 
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  onChange={selectedOption => {
                    handleSelectStatus(selectedOption.id)
                    let event = {
                      target: {
                        name: "status",
                        value: selectedOption,
                      },
                    }
                    validation.handleChange(event)
                  }}
                  onBlur={() => {
                    validation.handleBlur({
                      target: { name: "status" },
                    })
                  }}
                  value={validation.values.status || ""}
                  invalid={
                    validation.touched.status &&
                    validation.errors.status
                      ? true
                      : false
                  }
                />
                {validation.touched.status &&
                validation.errors.status ? (
                  <span className="text-danger small">
                    {CONSTANTS.STR_REQUIRED_FIELD}
                  </span>
                ) : null}
              </div>
            </Col>
            <Col xl={6}>
            <div className="mb-3">
                <Label className='form-label'>Date Reported</Label>
                <input
                  className="form-control"
                  type="date"
                  name="reported_at"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.reported_at || ''}
                  invalid={
                    !!(validation.touched.reported_at
                        && validation.errors.reported_at)
                }
                />
                {validation.touched.reported_at
                    && validation.errors.reported_at ? (
                    <span className="text-danger" type="invalid">
                        {validation.errors.reported_at}
                    </span>
                ) : null}
              </div>
            </Col>
            <Col xl={12}>
              <div className="mb-3">
                <Label className='form-label'>Description</Label>
                  <Input
                    type="textarea"
                    name="description"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.description || ""}
                    invalid={
                      validation.touched.description &&
                      validation.errors.description
                        ? true
                        : false
                    }
                  ></Input>
                  {validation.touched.description &&
                    validation.errors.description ? (
                      <FormFeedback type="invalid">
                        {validation.errors.description}
                      </FormFeedback>
                    ) : null}
                </div>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={onCloseClickModal}
            className="btn btn-light "
            data-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="submit"
            className={`btn ${getPrimaryButtonClass()}`}
          >
            Save Customer Incident
          </button>
        </div>
      </Form>
    </Modal>
  )
}

CustomerIncidentModal.propTypes = {
  onCloseClick: PropTypes.func,
  onSaveCustomerIncident: PropTypes.func,
  show: PropTypes.any,
}

export default CustomerIncidentModal